import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Text,
} from "@chakra-ui/react";
import {
  FiCalendar,
  FiFileText,
  FiPlus,
  FiRefreshCw,
  FiSearch,
  FiRepeat,
  FiStar,
} from "react-icons/fi";

const DashboardHeader = ({
  title,
  subtitle,
  searchValue,
  onSearchChange,
  rangeValue,
  onRangeChange,
  onRefresh,
  onOpenCreateInvoice,
  onOpenCreatePlan,
  onOpenCreateSubscription,
  showFilters = true,
  showCreate = true,
  showSearch = true,
}) => {
  return (
    <Flex
      direction={{ base: "column", lg: "row" }}
      align={{ base: "flex-start", lg: "center" }}
      justify="space-between"
      gap={4}
      mb={6}
    >
      <Box>
        <Heading size="lg">{title}</Heading>
        <Text color="gray.600">{subtitle}</Text>
      </Box>
      <HStack
        spacing={3}
        w={{ base: "full", lg: "auto" }}
        flexWrap={{ base: "wrap", lg: "nowrap" }}
        align="center"
      >
        {showFilters ? (
          <>
            {showSearch ? (
              <InputGroup maxW="280px" minW="220px" flex="1">
                <InputLeftElement pointerEvents="none">
                  <FiSearch />
                </InputLeftElement>
                <Input
                  placeholder="Search invoices, customers..."
                  value={searchValue}
                  onChange={(event) => onSearchChange(event.target.value)}
                  bg="white"
                />
              </InputGroup>
            ) : null}
            <HStack spacing={3} align="center" flexShrink={0}>
              <HStack flexShrink={0}>
                <FiCalendar />
                <Select
                  value={rangeValue}
                  onChange={(event) => onRangeChange(event.target.value)}
                  bg="white"
                  minW="160px"
                >
                  <option value="7d">Last 7 days</option>
                  <option value="30d">Last 30 days</option>
                  <option value="90d">Last 90 days</option>
                  <option value="all">All time</option>
                </Select>
              </HStack>
              <IconButton
                aria-label="Refresh data"
                icon={<FiRefreshCw />}
                onClick={onRefresh}
                variant="outline"
                bg="white"
              />
            </HStack>
          </>
        ) : null}
        {showCreate ? (
          <Menu>
            <MenuButton as={Button} leftIcon={<FiPlus />} colorScheme="blue">
              Create
            </MenuButton>
            <MenuList>
              <MenuItem icon={<FiFileText />} onClick={onOpenCreateInvoice}>
                Invoice
              </MenuItem>
              <MenuItem icon={<FiStar />} onClick={onOpenCreatePlan}>
                Subscription Plan
              </MenuItem>
              <MenuItem icon={<FiRepeat />} onClick={onOpenCreateSubscription}>
                Subscription
              </MenuItem>
            </MenuList>
          </Menu>
        ) : null}
      </HStack>
    </Flex>
  );
};

export default DashboardHeader;
